/* DHC B209 — compact information, non-destructive and idempotent. */
(function(){'use strict';
function boot(root){
 (root||document).querySelectorAll('.dhc-pdp-v931').forEach(function(pdp){
  if(pdp.dataset.dhcCompactReady==='1')return;
  var box=pdp.querySelector('.dhc-pdp-v931__buybox'),form=box&&box.querySelector('[data-dhc-product-form]');
  var shell=pdp.querySelector('[data-dhc-compact-shell]')||document.querySelector('[data-dhc-compact-shell]');
  if(!box||!form||!shell||shell.dataset.dhcCompactReady)return;
  var details=shell.querySelector('[data-dhc-compact-details]'),materials=shell.querySelector('[data-dhc-compact-materials]');
  if(!details||!materials)return;
  function move(n,to){if(n&&to&&n!==to&&!n.contains(to))to.appendChild(n);}
  var costume=box.querySelector('#DHCCostumeDetails');
  if(costume){
   var grid=costume.querySelector('.dhc-b196-details__grid');
   if(grid){Array.from(grid.children).forEach(function(n){
    var h=(n.querySelector('h3')||{}).textContent||'';
    if(/materials|fabric|care instructions/i.test(h))move(n,materials);
   });}
  }
  move(box.querySelector('#DHCProductHighlights'),details);
  move(box.querySelector('#DHCProductDetails'),details);
  move(costume,details);
  move(box.querySelector('.dhc-b199-standalone'),materials);
  move(box.querySelector('#DHCProductSpecifications'),details);
  var mp=shell.querySelector('[data-dhc-compact-materials-panel]');
  if(mp)mp.hidden=!materials.textContent.trim();
  form.insertAdjacentElement('afterend',shell);
  /* Delivery remains above the purchase form; duplicate shipping/help panels are retired. */
  /* Preserve original deep-link IDs, including the specifications and size guide. */
  if(!pdp.querySelector('#DHCProductDetails')){var dp=shell.querySelector('[data-dhc-compact-details-panel]');if(dp)dp.id='DHCProductDetails';}
  shell.hidden=false;shell.dataset.dhcCompactReady='1';pdp.dataset.dhcCompactReady='1';
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document);},{once:true});else boot(document);
document.addEventListener('shopify:section:load',function(e){boot(e.target);});
})();